import React, { useState, useEffect } from 'react';
import TileGroup from './TileGroup';
import SingleSite from './SingleSite';
import DropdownFilter from '../Administration/Filters/DropdownFilter';
import { addPivotItemKeyToUrl, getPivotItemKeyFromUrl } from '../../helpers/HelperMethods';
import AiBuilderCreditsUsage from './AiBuilderCreditsUsage';
import CopilotCreditsUsage from './CopilotCreditsUsage';
import { Pivot, PivotItem } from '@fluentui/react';

const MyCharges = ({ sites, aiBuilderCreditsUsage, copilotCreditsUsage }) => {

    const [filters, setFilters] = useState({});
    const [statusesToDisplay, setStatusesToDisplay] = useState([]);

    const chargesStatuses = [
        {
            id: 1,
            status: 'Active',
            label: 'Active'
        },
        {
            id: 2,
            status: 'Expired',
            label: 'Expired'
        },
        {
            id: 3,
            status: 'Disabled',
            label: 'Disabled'
        },
        {
            id: 4,
            status: 'Deleted',
            label: 'Deleted'
        },
        {
            id: 5,
            status: 'Archived',
            label: 'Archived'
        }
    ]

    const statusFilterOptions = chargesStatuses.map(x=>
        {
            return {
                key: x.status,
                value: x.label
            }
        }
    )

    useEffect(() => {
        return updateResults();
    }, [filters])

    const updateResults = () => {
        setStatusesToDisplay(filters.siteStatus ? chargesStatuses.filter(x => filters.siteStatus.split(",").includes(x.status)) : chargesStatuses);
    }

    const handleNoSelection = () => {
        setStatusesToDisplay([])
    }

    const _onFilterChange = (fieldName, value) => {
                setFilters({
            ...filters,
            [fieldName]: value
        });
    }

    const aiBuilderCreditsUsageTiles = aiBuilderCreditsUsage.map((x, index) =>
        <AiBuilderCreditsUsage usage={x} key={index} />
    )

    const copilotCreditsUsageTiles = copilotCreditsUsage.map((x, index) =>
        <CopilotCreditsUsage usage={x} key={index} />
    )
    
    const defaultSelectedKey = getPivotItemKeyFromUrl('SharePoint', 'MyCharges');

    return(
        <div>
            <Pivot styles={pivotStyles} defaultSelectedKey={defaultSelectedKey} onLinkClick={addPivotItemKeyToUrl('MyCharges')}>
                <PivotItem itemKey='SharePoint' headerText='SharePoint' itemCount={sites.length}>
                    <div className="cell">
                        <DropdownFilter 
                            fieldName='siteStatus'
                            title='Site Status'
                            onChange = {_onFilterChange}
                            noselection = {handleNoSelection}
                            includeSelectAll = {true}
                            values={statusFilterOptions}
                        />
                    </div>
                    <div>
                        {statusesToDisplay.map(x=> 
                            <TileGroup  
                                key={x.id}
                                groupBy={x.label} 
                                elements={sites.filter(charge => (charge.siteStatus === x.status)).map(s =>
                                    <SingleSite
                                        key={s.id}
                                        site={s}
                                        isCharge={true}
                                    />)}
                            />)}
                    </div>
                </PivotItem>
                <PivotItem itemKey='PowerPlatform' headerText='Power Platform' itemCount={aiBuilderCreditsUsageTiles.length + copilotCreditsUsage.length}>
                    <div style={defaultItemStyles}>
                    {[
                        aiBuilderCreditsUsageTiles,
                        copilotCreditsUsageTiles
                    ]}
                    </div>
                </PivotItem>
            </Pivot>
        </div>
    );
}

const pivotStyles = {
    root: {
        marginBottom: 20,
        whiteSpace: 'pre-wrap',
        //maxWidth: 'calc(100% - 450px)',
        //minWidth: 300
    },
    linkContent: {
        fontSize: 16,
        flex: 'auto'
    }
}

const defaultItemStyles = {
    display: 'flex',
    flexWrap: 'wrap'
}

export default MyCharges


// WEBPACK FOOTER //
// ./src/components/ManageCenter/MyCharges.js